export type SlotItem = {
  children: Array<SlotItem> | string
  props: any | null
}

export function extractText(slotContent: Array<SlotItem>) {
  return _join(slotContent.map(getText), ' ')
}

function getText(item: SlotItem): string {
  if (!item?.children) return item.props?.name ? `icon(${item.props.name})` : '' // icon name
  if (typeof item.children === 'string') return _trim(item.children) // text

  return _join(
    item.children.map((x) => getText(x)),
    ' '
  )
}

export function getCookieDomain(): string {
  const parts = _split(window.location.hostname, '.')
  if (parts.length === 1) return parts[0]
  return _join(_tail(parts), '.')
}
